import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../..";
import Header from "../../components/Header";
import { ApiService } from "../../core/api/api";
import { useFetching } from "../../core/hooks/useFetching";
import { BranchM, BranchModel, Region } from "../../core/models/Branch";
import { DebounceInput } from "react-debounce-input"

import styles from "../../styles/Branches.module.scss";
import {StorageKeys} from "../../core/utils/defaults";
import {message} from "antd";
import useWindowDimensions from "../../core/hooks/useWindowDimensions";
import {isElementInViewport, translit} from "../../core/utils/utils";
import {CloseOutlined} from "@ant-design/icons";
import LangSwitcher from "../../components/LangSwitcher";
import {FormattedMessage, useIntl} from "react-intl";

interface DomainObj {
  city_name: string
  url: string
}

const domains: DomainObj[] = [{"city_name":"dubai","url":"dubai.topgun.ru"},{"city_name":"минск","url":"minsk.topgun.ru"},{"city_name":"белгород","url":"belgorod.topgun.ru"},{"city_name":"владивосток","url":"vladivostok.topgun.ru"},{"city_name":"владимир","url":"vladimir.topgun.ru"},{"city_name":"грозный","url":"groznyy.topgun.ru"},{"city_name":"дзержинск","url":"dz.topgun.ru"},{"city_name":"екатеринбург","url":"ekaterinburg.topgun.ru"},{"city_name":"зеленоград","url":"zelenograd.topgun.ru"},{"city_name":"казань","url":"kzn.topgun.ru"},{"city_name":"калуга","url":"kaluga.topgun.ru"},{"city_name":"красная поляна","url":"kraspol.topgun.ru"},{"city_name":"краснодар","url":"krasnodar.topgun.ru"},{"city_name":"красноярск","url":"krsk.topgun.ru"},{"city_name":"липецк","url":"lipetsk.topgun.ru"},{"city_name":"магадан","url":"magadan.topgun.ru"},{"city_name":"мурманск","url":"murmansk.topgun.ru"},{"city_name":"нижний новгород","url":"nn.topgun.ru"},{"city_name":"новосибирск","url":"nsk.topgun.ru"},{"city_name":"новый уренгой","url":"nu.topgun.ru"},{"city_name":"омск","url":"omsk.topgun.ru"},{"city_name":"орел","url":"orel.topgun.ru"},{"city_name":"пенза","url":"penza.topgun.ru"},{"city_name":"пермь","url":"perm.topgun.ru"},{"city_name":"петрозаводск","url":"ptz.topgun.ru"},{"city_name":"петропавловск-камчатский","url":"petropavlovsk-kamchatskiy.topgun.ru"},{"city_name":"пушкино","url":"pushkino.topgun.ru"},{"city_name":"ростов","url":"rnd.topgun.ru"},{"city_name":"рязань","url":"ryazan.topgun.ru"},{"city_name":"самара","url":"samara.topgun.ru"},{"city_name":"сочи","url":"sochi.topgun.ru"},{"city_name":"ставрополь","url":"stavropol.topgun.ru"},{"city_name":"сургут","url":"surgut.topgun.ru"},{"city_name":"сухум","url":"sukhum.topgun.ru"},{"city_name":"тула","url":"tula.topgun.ru"},{"city_name":"тюмень","url":"tyumen.topgun.ru"},{"city_name":"хабаровск","url":"khabarovsk.topgun.ru"},{"city_name":"челябинск","url":"chelyabinsk.topgun.ru"},{"city_name":"ярославль","url":"yaroslavl.topgun.ru"}]

const Branches: FC = () => {
  
  const { store } = useContext(Context)
  const navigate = useNavigate()
  const location = useLocation()
  const { width } = useWindowDimensions()

  const {formatMessage: f} = useIntl()

  const [anim1, setAnim1] = useState(false);
  
  const [searchTextAp, setSearchTextAp] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchState, setSearchState] = useState(false);
  const [searchOpenned, setSearchOpenned] = useState(false);
  
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [isSearchShown, setIsSearchShown] = useState(false);
  const [isSearchSlided, setIsSearchSlided] = useState(false);

  const getCitiesHeight = (id: number) => {
    const el = document.getElementById(`region_${id}`);
    if (el != undefined) {
      return `${el.clientHeight}px`;
    }
    return "0px";
  }

  const onSearchText = (event: any) => {
    let txt = event.target.value

    console.log(`Search Action: ${txt}`, txt)

    setSearchText(prev => prev = txt)
    localStorage.setItem(StorageKeys.BRANCH_SEARCH, txt)

    if (txt == "" || txt.length <= 2) {
      store.setBranches(store.branchesAll)
      localStorage.setItem(StorageKeys.BRANCHES_FILTERED, JSON.stringify(store.branchesAll))
      return
    }

    let brnchs: BranchModel[] = []
    let num = 0
    let itmX: any | null = null

    store.branchesAll.forEach(branch => {
      let brnch: BranchModel = {...branch}
      let tst2 = false
      
      if (branch.regions != undefined) {
        let rgns: Region[] = []
        branch.regions.forEach(region => {
          let itms: BranchM[] = []
          let rgg: Region = {...region}
          let tst1 = false

          let txt_yo = txt.replace("е", "ё").replace("е", "ё").replace("е", "ё").replace("е", "ё").replace("е", "ё").replace("е", "ё").replace("е", "ё").replace("е", "ё")

          if (
            region.region.toLowerCase().includes(txt.toLowerCase()) ||
            region.region.toLowerCase().includes(txt_yo.toLowerCase())
          ) {
            tst1 = true
            tst2 = true
          }

          region.items.forEach(item => {
            if (
              (
                item.title.toLowerCase().includes(txt.toLowerCase()) ||
              (item.address != undefined && item.address.toLowerCase().includes(txt.toLowerCase()))
              ) || (
                item.title.toLowerCase().includes(txt_yo.toLowerCase()) ||
                (item.address != undefined && item.address.toLowerCase().includes(txt_yo.toLowerCase()))
              ) || (
                region.region.toLowerCase().includes(txt.toLowerCase()) ||
                region.region.toLowerCase().includes(txt_yo.toLowerCase())
              )
            ) {
              itms.push(item)
              itmX = item
              num += 1
              tst1 = true
              tst2 = true
            } else {
              if (tst1 && region.items.length == 1) {
                itms.push(item)
                itmX = item
                num += 1
              }
            }
          })
          rgg.openned = true
          rgg.items = itms

          if (tst1 == true) {
            rgns.push(rgg)
          }
        })
        brnch.regions = rgns
      }
      
      if (tst2) {
        brnchs.push(brnch)
      }
    })

    console.log(brnchs)

    localStorage.setItem(StorageKeys.BRANCHES_FILTERED, JSON.stringify(brnchs))

    store.setBranches(brnchs)

    console.log("num", num, itmX)
    if (num == 1) {
      window.location.href = `/barbershop/${translit(itmX.name.toLowerCase())}`
    }
  }

  const [fetchBranches, isBranchesLoading, errBran] = useFetching(async () => {
    let res: any = await ApiService.branches.getAll();

    if (res.data.branches == undefined || res.data.branches == null) {
      message.error("Возникла неизвестная ошибка! Повторите попытку позже.");
      return;
    }

    let branches: any[] = [...res.data.branches]

    branches = branches.sort((a: any, b: any) => {
      if (a.id > b.id) {
        return 1
      } else if (a.id < b.id) {
        return -1
      } else {
        return 0
      }
    })
    
    let lst: BranchModel[] = []
    let lstItms: BranchM[] = []
    branches.forEach((branch: BranchModel) => {
      let item: BranchModel = {...branch};
      if (item.regions != undefined) {
        item.regions.forEach((region) => {
          region.openned = true;
          region.opennedd = true;
        })
        item.regions = branch.regions!.sort((a: any, b: any) => {
          if (a.id > b.id) {
            return 1
          } else if (a.id < b.id) {
            return -1
          } else {
            return 0
          }
        })
      }
      lst.push(item);
    })

    console.log(lst)

    let brn0: any[] = [], brn1: any[] = []
    lst[0].regions!.forEach((reg: any) => {
      if (reg.region.toLowerCase() == "москва") {
        brn0.push(reg)
      } else if (reg.region.toLowerCase() == "санкт-петербург") {
        brn0.push(reg)
      } else {
        brn1.push(reg)
      }
    })

    lst[0].regions = [...brn0, ...brn1]

    console.log(lst)

    store.setBranches(lst)

    setTimeout(() => {
      if (res == null) {
        return;
      }

      let json: BranchModel[] = [...branches];

      let lst: BranchModel[] = [], lsts: any[] = [];
      json.forEach((branch, ixx) => {
        let itm = {...branch};
        if (branch.regions != undefined) {
          let rgn: Region[] = [];

          // branch.regions = branch.regions.sort((a: any, b: any) => {
          //   if (a.id > b.id) {
          //     return 1
          //   } else if (a.id < b.id) {
          //     return -1
          //   } else {
          //     return 0
          //   }
          // })
          lsts.push(`br_ttl_${ixx}`)
          branch.regions.forEach((region, ix) => {
            let rg = {...region};
            const el = document.getElementById(`regions_${rg.id}`);
            if (el != null) {
              rg.height = `${el.clientHeight + 0}px`;
            }
            lsts.push(`br_itm_${ixx}_${ix}`)
            rgn.push(rg);
          })
          itm.regions = rgn
        }
        lst.push(itm)
      })

      store.setBranchesMapIds(lsts)

      setTimeout(() => {
        let lstFin: BranchModel[] = []
        lst.forEach((element, ix) => {
          let item = {...element}
          if (item.regions != undefined) {
            let rgn: Region[] = []
            item.regions.forEach((region, i) => {
              if (i == 0 && ix == 0) {
                region.openned = false
                region.opennedd = false
              } else {
                region.openned = false
                region.opennedd = false
              }
              region.items = region.items.sort((a: any, b: any) => {
                if (a.id > b.id) {
                  return 1
                } else if (a.id < b.id) {
                  return -1
                } else {
                  return 0
                }
              })
              rgn.push(region)
            })
            item.regions = rgn
          }
          lstFin.push(item)
        })

        let brn0: any[] = [], brn1: any[] = []
        lstFin[0].regions!.forEach((reg: any) => {
          if (reg.region.toLowerCase() == "москва") {
            brn0.push(reg)
          } else if (reg.region.toLowerCase() == "санкт-петербург") {
            brn0.push(reg)
          } else {
            brn1.push(reg)
          }
        })

        lstFin[0].regions = [...brn0, ...brn1]

        store.setBranches(lstFin)
        store.setBranchesAll(lstFin)

        //runAnimations()

        localStorage.setItem(StorageKeys.BRANCHES, JSON.stringify(lstFin));
        localStorage.setItem(StorageKeys.BRANCHES_FILTERED, JSON.stringify(lstFin));


        let host = window.location.host
        // let host = "rnd.topgun.ru"
    
        const connectedDomain = domains.find(v => v.url == host)
        if (connectedDomain != undefined) {
          onSearchText({target: {value: connectedDomain.city_name}})
        } else {
          // onSearchText({target: {value: "минск"}})
          window.location.href = "https://topgun.ru/barbershops"
        }

        setTimeout(() => {
          setAnim1(true)

          const searchSaved = localStorage.getItem(StorageKeys.BRANCH_SEARCH);
          if (searchSaved != null && searchSaved != "") {
            //setSearchState(true);
            //onSearchText({target: {value: searchSaved}})
          }
        }, 300);
      }, 100);
    }, 10);
  });

  const navTo = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    const url = event.target.pathname || "/";
    
    store.setIsFaderVisible(true);
    setTimeout(() => {
      store.setIsFaderShown(true);
      setTimeout(() => {
        navigate(url);
      }, 400);
    }, 100);
  }

  const toggleBranches = (region: Region) => {
    let newItms: any[] = [];

    store.branches.forEach(brnch => {
      let itm: BranchModel = {...brnch};
      if (brnch.regions != undefined) {
        let rgns: Region[] = [];
        brnch.regions.forEach(rgn => { 
          let rg: any = {...rgn};
          if (rgn.region == region.region) {
            
            if (region.openned) {
              rg.openned = !rgn.openned;
            } else {
              rg.opennedd = !rgn.opennedd;
            }
          }
          rgns.push(rg);
        });
        itm.regions = rgns;
      }
      newItms.push(itm);
    });
  
    store.setBranches(newItms)

    setTimeout(() => {
      let newItms2: any[] = [];
      store.branches.forEach(brnch => {
        let itm: BranchModel = {...brnch};
        if (brnch.regions != undefined) {
          let rgns: Region[] = [];
          brnch.regions.forEach(rgn => { 
            let rg: any = {...rgn};
            if (rgn.region == region.region) {
              
              if (!region.openned) {
                rg.openned = !rgn.openned;
              } else {
                rg.opennedd = !rgn.opennedd;
              }
            }
            rgns.push(rg);
          });
          itm.regions = rgns;
        }
        newItms2.push(itm);
      });
  
      store.setBranches(newItms2)

      // setTimeout(() => {
      //   runAnimations()
      //   setTimeout(() => {
      //     runAnimations()
      //     setTimeout(() => {
      //       runAnimations()
      //       setTimeout(() => {
      //         runAnimations()
      //         setTimeout(() => {
      //           runAnimations()
      //           setTimeout(() => {
      //             runAnimations()
      //             setTimeout(() => {
      //               runAnimations()
      //             }, 100);
      //           }, 100);
      //         }, 100);
      //       }, 100);
      //     }, 100);
      //   }, 100);
      // }, 100);
    }, region.openned ? 400 : 10);
  }

  const openSearch = () => {
    setIsSearchVisible(true);
    setTimeout(() => {
      setIsSearchShown(true);
      setTimeout(() => {
        setIsSearchSlided(true);
      }, 400);
    }, 200);
  }

  const goSearch = () => {}

  const closeSearch = () => {
    setIsSearchSlided(false);
    window.scrollTo({ behavior: "auto", top: 10})
    setTimeout(() => {
      window.scrollTo({ behavior: "auto", top: 0})
    }, 100);
    setTimeout(() => {
      setIsSearchShown(false);
      setTimeout(() => {
        setIsSearchVisible(false);
      }, 400);
    }, 400);
  }

  const runBottomOpacity = (el: HTMLElement | null, delay: number = 0, asc: number = 0) => {
    if (el != null) {
      if (width <= 960) {
        delay = 40;
      }

      if (el.style.bottom == "") {
        el.style.bottom = "-35px";
      }

      if (el.style.opacity == "") {
        el.style.opacity = "0";
      }

      if (isElementInViewport(el)) {
        let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay + asc);
        let spl = (dell) / 100;
        if (spl > parseInt(el.style.opacity)) {
        }
        el.style.opacity = `${spl}`;
        
        let ix = ((dell) / 4) - 15;

        if (ix > parseInt(el.style.bottom.replace("px", ""))) {
          
        }
        if (ix < 0) {
          el.style.bottom = `${ix}px`;
        } else {
          el.style.bottom = `0px`;
        }
      } else {
        if (el.style.opacity == "0") {
          el.style.opacity = `0`;
          el.style.bottom = `-35px`;
        }
      }
    }
  }

  const runOpacity = (el: HTMLElement | null, delay: number = 0, asc: number = 0) => {
    if (el != null) {
      if (width <= 960) {
        asc = -40;
      }

      if (el.style.opacity == "") {
        el.style.opacity = `0`;
      }

      let dell = window.innerHeight - ((el.getBoundingClientRect().y + el.getBoundingClientRect().height) - delay + asc);
      let spl = dell / 100;  
      console.log(spl, parseInt(el.style.opacity))
      if (isElementInViewport(el) && spl > 0) {
        
        if (el.style.opacity == "") {
          el.style.opacity = `${spl}`;
        } else {
          
          el.style.opacity = `${spl}`;
        }
      } else {
        if (parseInt(el.style.opacity) == 0) {
          el.style.opacity = `0`;
        }
      }
    }
  }

  const runAnimations = () => {
    store.branchesMapIds.forEach((id: string) => {
      const itm = document.getElementById(id)
      if (itm != null) {
        if (width < 768) {
          runOpacity(itm, 0)
        } else {
          runOpacity(itm, 30)
        }
      }
    })
    //requestAnimationFrame(runAnimations)
  }

  const clearText = () => {
    onSearchText({target: {value: ""}})
  }

  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
    
    store.setAnimationToggle(true)

    fetchBranches()

    const onScroll = (event: any) => {
      const scrollTop = event.target.scrollingElement.scrollTop;
    
      //runAnimations()

      const pb3 = document.getElementById("pb3")
      const pb4 = document.getElementById("pb4")

      runOpacity(pb3, 1000)
      runOpacity(pb4, 1100)

    }

    setTimeout(() => {
      const pb1 = document.getElementById("pb1")
      const pb2 = document.getElementById("pb2")
      const langsw6 = document.getElementById("langsw6")

      if (pb1 != null && pb2 != null && langsw6 != null) {
        pb2.style.opacity = "1"
        langsw6.style.opacity = "1"
        setTimeout(() => {
          pb1.style.opacity = "1"
        }, 200)
      }
    }, 100);

    document.addEventListener('scroll', onScroll);

    return () => {
      document.removeEventListener('scroll', onScroll);
    }
  }, [])
  
  return (
    <>
      <div className={styles.bgg}></div>

      <div style={{}} className={styles.page_blink + "" + " " + styles.right + " " + styles.toped3} id="pb1"></div>

      <div className={styles.page_blink + " " + styles.reddz + " " + styles.toped} id="pb2"></div>

      <div className={styles.search_wrap} style={{display: isSearchVisible ? "none" : "none"}}>
        <div className={styles.search_wrap__bg} style={{opacity: isSearchShown ? "1" : "0"}} onClick={() => closeSearch()}></div>
        <div className={styles.search_wrap__pane} style={{top: isSearchSlided ? "24px" : "-120px"}}>
          <div className={styles.search_wrap__pane__block}>
            <div className={styles.swpb_wrap}>
              <div className={styles.swpb_wrap__input}>
                <input type="text" value={searchTextAp} onChange={(event) => setSearchTextAp(event.target.value)} placeholder="найти свой TOPGUN" />
              </div>
            </div>
            <button onClick={() => {
              onSearchText({target: {value: searchTextAp}})
              closeSearch()
            }}><img src="/assets/images/search_btn.svg" /></button>
          </div>
        </div>
      </div>

      <div className={styles.section_top} style={{
        opacity: anim1 ? "1" : "0"
      }}>
        <div className="container">
          <div className="row">
            <div className={"col-12 " + styles.posrel}>
              <div className={styles.lang} id="langsw6" style={{opacity: "0"}}><LangSwitcher /></div>
              
              {/* <div className={styles.search_branch + (store.isMobile && searchState ? " " + styles.openned : "")}>
                <div><DebounceInput debounceTimeout={800} placeholder={f({id: "find_topgun"})} value={searchText} onChange={onSearchText} /></div>
                <div>
                  <img src={searchText.length > 0 ? "/assets/images/close.svg" : "/assets/images/search.svg"} onClick={() => searchText.length > 0 ? clearText() : (width > 768 ? setSearchState(prev => prev = !prev) : openSearch())} />
                </div>
              </div> */}

              <div className={styles.brnchs}>
                {store.branches.length == 0 ? <div className={styles.branch}>
                  <div className={styles.branch_wrap}>
                    <div className={styles.branch_country}>
                      <h3><FormattedMessage id="branches_clear" /></h3>
                    </div>
                  </div>
                </div> : <></>}
                {store.branches.map((branch: BranchModel, ixx) => <div className={styles.branch}>
                  <div className={styles.branch_wrap}>
                    <div className={styles.branch_country} id={`br_ttl_${ixx}`}>
                      <h1>{store.locale == "ru-RU" ? branch.country : branch.country_eng}</h1>
                    </div>

                    <div className={styles.flex_wrap}>
                      {branch.regions != undefined ? branch.regions.map((region, ix) => (region.items.length > 1 || searchText != "") ? <div className={styles.branch_region + (region.opennedd ? " " + styles.br_abs_op : "")} id={`br_itm_${ixx}_${ix}`}>
                        <div className={styles.branch_region__title} onClick={() => toggleBranches(region)}>{store.locale == "ru-RU" ? region.region : region.region_eng} <span className={region.openned ? styles.openned : ""}><img src="/assets/images/arrow_up.svg" /></span></div>
                        <div className={styles.branch_region__items + ((ix != 0 && ix != 1) || ixx != 0 ? " " + styles.ffw : "")} id={`regions_${region.id}`} style={{
                          height: region.openned ? (searchText != "" ? "auto" : region.height) : "0px",
                          //paddingTop: searchText != "" ? (region.openned ? "24px" : "0px") : (region.opennedd ? "24px" : "0px"),
                        }}>
                          {region.items.map(item => <div><a className={styles.cardx} href={`/b/${translit(item.title.toLowerCase())}`}>
                            <div className={styles.img} style={{backgroundImage: `url(${item.about != undefined ? item.about.split(";")[0] : "/assets/images/blog/ph_bg.png"})`}}></div>
                            <div className={styles.title}>{store.locale == "ru-RU" ? item.title : item.title_eng}</div>
                            <div className={styles.desc}>{store.locale == "ru-RU" ? item.address : translit(item.address!)}</div>
                            <a href={`tel:${item.phone}`} className={styles.phone}>{item.phone}</a>
                          </a></div>)}
                        </div>
                      </div> : (region.items.length == 0 ? <div className={styles.branch_city} id={`br_itm_${ixx}_${ix}`}>
                          <a href={`/b/rg/${region.id}`}>{store.locale == "ru-RU" ? region.region : region.region_eng}</a>
                      </div> : <div className={styles.branch_city} id={`br_itm_${ixx}_${ix}`}>
                          <a href={`/b/${translit(region.items[0].title.toLowerCase())}`}>{store.locale == "ru-RU" ? region.region : region.region_eng}</a>
                      </div>)) : <></>}
                    </div>

                  </div>
                </div>)}
              </div>

            </div>
          </div>
        </div>
      </div>

      <div style={{}} className={styles.page_blink + "" + " " + styles.right + " " + styles.toped5} id="pb3"></div>

      <div className={styles.page_blink + " " + styles.reddz + " " + styles.toped6} id="pb4"></div>

    </>
  )
}

export default observer(Branches)

/**
 
                    {branch.cities != undefined ? <div className={styles.ctsts}>
                      {branch.cities.map(city => <div className={styles.branch_city}>
                        <a href={city.url} onClick={navTo}>{city.title}</a>
                      </div>)}
                    </div> : <></>}
 */